// extracted by mini-css-extract-plugin
export default {"chats":"Chats_chats__QPmLs","singleChat":"Chats_singleChat__RSWHO","mychats":"Chats_mychats__L+ENE"};